// assets
import { DashboardOutlined, DollarOutlined, FormOutlined } from '@ant-design/icons';
import { types as routes } from '../reducers/rotas.actions';

// icons
const icons = {
  DashboardOutlined,
  FormOutlined,
  DollarOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: 'group-integracao',
  title: 'Integrações',
  type: 'group',
  children: [
    {
      id: 'integracao-bradesco',
      title: 'Consulta Massiva Bradesco',
      type: 'item',
      icon: icons.FormOutlined,
      breadcrumbs: false,
      url: '/integracao/consulta-massiva',
      action: routes.CONSULTA_MASSIVA,
      params: { id: 2 },
      restricted: ['AD']
    },
    {
      id: 'integracao-itau',
      title: 'Consulta Massiva Itaú',
      type: 'item',
      icon: icons.FormOutlined,
      breadcrumbs: false,
      url: '/integracao/itau/consulta-massiva',
      action: routes.CONSULTA_MASSIVA_ITAU,
      params: { id: 2 },
      restricted: ['AD']
    }
    // {
    //   id: 'integracao-santander',
    //   title: 'Consulta Massiva Santander',
    //   type: 'item',
    //   icon: icons.FormOutlined,
    //   breadcrumbs: false,
    //   url: '/integracao/santander/consulta-massiva',
    //   action: routes.CONSULTA_MASSIVA_SANTANDER,
    //   params: { id: 2 },
    //   restricted: ['AD']
    // }
  ]
};

export default dashboard;
